import { EventEmitter } from '@angular/core';

export class MaxDialogRef<T = any> {
    afterCLosed = new EventEmitter<T>();

    close(data?: T): void {
        this.afterCLosed.emit(data);
    }
}

export class MaxDialogConfig<T = any> {
    data?: T;
}
